export class WorkerRequest {
    workerId: number;
    fullName: string;
    email: string;
    changePassword: boolean;
    password: string;
}